module.exports = __webpack_public_path__ + "img/weixin.7c6794ac.jpg";